import { Plugin } from 'interface/plugin/plugin.interface';
import { PluginActionType } from 'redux/plugin/plugin.type';

export function setPlugins(payload: {plugins: Plugin[]}) {
  return {
    type: PluginActionType.SET_PLUGINS,
    payload,
  }
}
